module.exports = __webpack_public_path__ + "media/goforajourney/img/italia-card-3dbbef5eab6cf1925bdb3ebdf903d616.webp";